import { useHistory } from "react-router-dom"
import { getCookie } from "../helpers/cookies"
import { parseJwt } from "../helpers/jwt"

export const useBarrier = (rolesAceptados) => {
  // checkeo permisos
  const history = useHistory(),
    jwtCokie = getCookie("jwt")

  if (!jwtCokie) history.push("/login")

  try {
    const tkn = parseJwt(jwtCokie),
      ok = rolesAceptados.includes(tkn.role)

    if (!ok) history.push("/")
  } catch (error) {
    history.push("/")
  }
}
